<template>
  <q-page style="">
        <div class="row justify-center" style="margin: auto; height: calc(100vh - 128px);">
            <div class="col-12 col-md-9 q-pa-lg" style="height: 100%;">
                <q-card  style="border-radius: 1rem !important; box-shadow: none !important; height: 100%; background: #fff; position: relative; width: 100%;"> 
                    <q-card-section style=" margin: 0;position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%);  width: 100%;">
                    <div class="row justify-center q-pa-md" style="margin-top: auto; margin-bottom: auto;">
                        <div class="col-xs-12 col-sm-5 col-md-6 col-lg-5 q-py-md q-px-sm text-center">
                            <img  src="@/assets/wrong.png" style="height: auto; width: 100%; max-height: 450px !important;" >
                        </div>
                        <div class="col-xs-12 col-sm-7 col-md-6 col-lg-5 q-py-md q-px-sm" style="padding-left:20px">
                            <div class="text-bold q-mb-xs" style="font-size: 24px !important;">404</div>
                            
                            <div class="text-bold q-mb-sm" style="font-size: 16px !important;">
                                Page not found.
                             </div>
                                <div>
                                We couldn't find the page you're looking for.
                                
                            </div>
                            
                            <br>
                            <q-btn unelevated style="background: #ff6666; color: white; border-radius: 0.5rem;"  label="Contact Us" @click="reroute()" ></q-btn>
                        </div>
                    </div>
                    </q-card-section>
                </q-card>
            </div>
        </div>
  </q-page>

  <!-- CODE HISTORY -->
            <!-- <q-card  class="content-wrapper"> 
                <div class="column">
                    <div class="row q-pa-lg col-sm-10 col-md-10 col-xs-10 justify-center" >
                        <img class="col-sm-12 col-md-7 col-xs-12" src="@/assets/error404_2.png"/>
                        <div class="self-center  bold text-weight-medium col-sm-12 col-md-4 col-xs-12" >
                            <div class="text-h3 text-bold" style="color:#355dc4;" >PAGE NOT FOUND</div> 
                            <div class="text-h6" style="color:#8f969e;">We couldn't find the page you're looking for.</div>
                            <div class="col self-center q-pa-md">
                                <q-btn icon-right="fas fa-caret-right"  class="q-mr-sm q-pa-sm"  unelevated rounded color="accent" text-color="white"  label="Contact Us" @click="reroute()" ></q-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </q-card> -->

            <!-- <q-card  class="content-wrapper  "> 
                <div class="column">
                    <div class="row q-pa-lg col-sm-10 col-md-10 col-xs-10 justify-center" >
                            <img class="col-sm-12 col-md-7 col-xs-12"  src="@/assets/error404.png"/>
                            <div></div>
                            <div class="self-center  bold text-weight-medium col-sm-12 col-md-4 col-xs-12" style="color:#0000ffa6;">
                                
                                <div class="text-h4">PAGE NOT FOUND</div> 
                                <div class="text-h6">We couldn't find the page you're looking for.</div>
                                <div class="col self-center">
                                    <q-btn unelevated rounded color="indigo" icon="call" label="AHAM Contact Us" @click="reroute()" ></q-btn>
                                </div>
                            </div>
                    </div>
                </div>
            </q-card> -->

             <!-- <q-card  class="content-wrapper  "> 
                <div class="column">
                    <div class="row q-pa-lg col-sm-10 col-md-10 col-xs-10 justify-center" >
                            <img class="col-sm-12 col-md-7 col-xs-12"  src="@/assets/error404_3.jpg"/>
                            <div></div>
                            <div class="self-center  bold text-weight-medium col-sm-12 col-md-4 col-xs-12" style="color:#0000ffa6;">
                                
                                <div class="text-h4">PAGE NOT FOUND</div> 
                                <div class="text-h6">We couldn't find the page you're looking for.</div>
                                <div class="col self-center">
                                    <q-btn unelevated rounded color="indigo" icon="call" label="AHAM Contact Us" @click="reroute()" ></q-btn>
                                </div>
                            </div>
                    </div>
                </div>
            </q-card> -->

</template>
<script>
export default {
    methods:{
      reroute:function(){
        window.location.href = 'https://affinhwangam.com/get-in-touch/contact-us'
    }

    },mounted(){
        this.$q.loading.hide()
      /*  var url = new URL(window.location.href);
        var url_string = url.search;

       this.$store.dispatch('Logging',{
            appid : '2',
            typeid :'4', 
            str : 'MAINTENANCE PAGE --> ' + url_string
        }); */
  }
 
}
</script>